import { render, staticRenderFns } from "./email.vue?vue&type=template&id=adce679a&scoped=true"
import script from "./email.vue?vue&type=script&lang=js"
export * from "./email.vue?vue&type=script&lang=js"
import style0 from "./email.vue?vue&type=style&index=0&id=adce679a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adce679a",
  null
  
)

export default component.exports